import type { CostoActividad } from '../lib/supabase';

export type DatosEdicionCostoActividad = Pick<CostoActividad,
  'descripcion' | 'monto' | 'fecha' | 'tipo_costo' | 'requiere_reembolso' | 'es_donacion'> & {
    producto_id: string | null;
    produccion_id: string | null;
  };

/** Evita reenviar campos intactos del formulario, incluidos los vínculos vacíos. */
export const obtenerCambiosCostoActividad = (
  anterior: CostoActividad,
  nuevo: DatosEdicionCostoActividad,
): Partial<DatosEdicionCostoActividad> => {
  const valoresAnteriores: DatosEdicionCostoActividad = {
    descripcion: anterior.descripcion,
    monto: Number(anterior.monto),
    fecha: anterior.fecha,
    tipo_costo: anterior.tipo_costo,
    requiere_reembolso: anterior.requiere_reembolso ?? false,
    es_donacion: anterior.es_donacion ?? false,
    producto_id: anterior.producto_id || null,
    produccion_id: anterior.produccion_id || null,
  };
  return Object.fromEntries(Object.entries(nuevo).filter(([campo, valor]) =>
    valor !== valoresAnteriores[campo as keyof DatosEdicionCostoActividad]));
};
